import { render, staticRenderFns } from "./Xiaoyuanfengjing.vue?vue&type=template&id=6755ed8c&scoped=true&"
import script from "./Xiaoyuanfengjing.vue?vue&type=script&lang=js&"
export * from "./Xiaoyuanfengjing.vue?vue&type=script&lang=js&"
import style0 from "./Xiaoyuanfengjing.vue?vue&type=style&index=0&id=6755ed8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755ed8c",
  null
  
)

export default component.exports